import { render } from "./BlCollectionAdd.vue?vue&type=template&id=7827e152"
import script from "./BlCollectionAdd.vue?vue&type=script&lang=js"
export * from "./BlCollectionAdd.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__